module.exports = __webpack_public_path__ + "img/news_page_gerb_article_full.895570b7.jpg";